import GroupIcon from './component'

export default GroupIcon
